export default "__VITE_ASSET__DYxctAxF__"